import SearchIcon from "@mui/icons-material/Search"
import TuneIcon from "@mui/icons-material/Tune"
import { IconButton, InputBase } from "@mui/material"
import React, { Dispatch, SetStateAction } from "react"
import { Box } from "@mui/system"
import { customPalette } from "../../../theme"
import { BaseSelectInput, BaseSelectOption } from "../inputs/select-input/BaseSelectInput"
import { FilterListDrawer } from "./FilterListDrawer"

interface IProps<T> {
  searchStateLabel: string
  searchState: string | undefined
  labelFilter?: string | undefined
  selectedOption?: T | undefined
  options?: BaseSelectOption<T>[]
  isFilterDrawer: boolean
  fetchOnlyMyData?: boolean // mandatory when isFilterDrawer=true
  setFetchOnlyMyData?: Dispatch<SetStateAction<boolean>>

  handleSearch(value: string): void

  triggerSearch?(): void

  handleChange?(selectedValue: T): void
}

export function SearchAndFilter<T>({
  searchStateLabel,
  searchState,
  labelFilter,
  selectedOption,
  options,
  isFilterDrawer,
  fetchOnlyMyData = true,
  setFetchOnlyMyData,
  handleSearch,
  triggerSearch,
  handleChange,
}: Readonly<IProps<T>>): React.JSX.Element | null {
  const [openDrawerFilter, setOpenDrawerFilter] = React.useState(false)

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      flexDirection="row"
      gap={1}
      width="100%"
      sx={{ py: 1 }}>
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault()
          if (triggerSearch) {
            triggerSearch()
          }
        }}
        sx={{
          flex: 3,
          p: "2px 4px",
          display: "flex",
          alignItems: "center",
          backgroundColor: customPalette.white,
          borderRadius: 3,
        }}>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          value={searchState}
          placeholder={searchStateLabel}
          inputProps={{ "aria-label": "search" }}
          endAdornment={
            <IconButton type="submit">
              <SearchIcon sx={{ margin: "0 8px" }} />
            </IconButton>
          }
          onChange={(e: { target: { value: any } }) => {
            handleSearch(e.target.value)
          }}
        />
      </Box>

      {options && labelFilter && (
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", minWidth: "250px" }}>
          <BaseSelectInput
            id={`labelFilter${labelFilter}`}
            label={labelFilter}
            selectedOption={selectedOption}
            options={options}
            mode="direct"
            handleChange={handleChange}
            isBeemShot
            size="small"
          />
          {isFilterDrawer && setFetchOnlyMyData && (
            <IconButton onClick={() => setOpenDrawerFilter(true)} sx={{ background: "#C9FFE8", borderRadius: 2, ml: 2 }}>
              <TuneIcon fontSize="medium" sx={{ color: "#009069" }} />
            </IconButton>
          )}
        </Box>
      )}

      {isFilterDrawer && setFetchOnlyMyData && (
        <FilterListDrawer
          openDrawerFilter={openDrawerFilter}
          fetchOnlyMyData={fetchOnlyMyData}
          setFetchOnlyMyData={setFetchOnlyMyData}
          setOpenDrawerFilter={setOpenDrawerFilter}
        />
      )}
    </Box>
  )
}
